import { createContext, useContext, useEffect, useState } from "react";

const translations = {
  fr: {
    nav_shop: "Boutique",
    nav_drops: "Drops",
    nav_story: "Histoire",
    nav_contact: "Contact",
    nav_admin: "Admin",
    cart: "Panier",
    drop_live: "Drop 01 — En vente",
    hero_subtitle:
      "Un uniforme tout noir pour la rue. Coupes lourdes, coutures brutes, étoile verte signature. Édition limitée. Porté fort.",
    hero_shop: "Voir le drop",
    hero_story: "Notre histoire",
    hero_est: "★ EST. 2025",
    hero_tagline: "Tout Noir / Crest Vert",
    featured_kicker: "Featured · Drop 01",
    featured_title: "Les essentiels",
    view_all: "Tout voir",
    story_kicker: "Notre Histoire",
    story_title_1: "Fait",
    story_title_2: "dans le",
    story_title_3: "noir.",
    story_body:
      "ALLSTAR est une marque streetwear obsédée par une seule couleur — le noir. On coupe des tissus lourds, on finit avec des coutures brutes, et on tamponne chaque pièce avec le crest étoile verte. Pas de collections pour tout le monde. Des séries limitées pour ceux qui font attention.",
    stat_1: "Limité",
    stat_2: "Lourd",
    stat_3: "Tout Noir",
    shop_kicker: "La Boutique",
    shop_title: "Tous les produits",
    pieces_live: (n) => `${n} ${n === 1 ? "pièce" : "pièces"} en vente`,
    cat_all: "Tout",
    cat_tshirt: "T-Shirts",
    cat_tracksuit: "Tracksuits",
    cat_hoodie: "Hoodies",
    cat_tuque: "Tuques",
    cat_manteau: "Manteaux",
    add_cart: "Ajouter au panier",
    featured_badge: "Featured",
    stock_left: (n) => `${n} restant`,
    sold_out: "Épuisé",
    sizes: "Tailles",
    empty_drop: "Rien dans cette catégorie. Bientôt.",
    empty_all: "Aucun produit. Drop bientôt.",
    footer_shop: "Boutique",
    footer_all: "Tous les produits",
    footer_tees: "T-Shirts",
    footer_tracksuits: "Tracksuits",
    footer_follow: "Suivre",
    footer_tagline:
      "Fait dans le noir. Porté fort. Drop 01 — tout noir, partout.",
    footer_rights: "© ALLSTAR — Tout Noir, Partout",
    footer_made: "Fait pour la rue",
    popup_title: "Rejoins le club",
    popup_subtitle: "Reçois en avant-première les drops et offres exclusives ALLSTAR.",
    popup_email: "Adresse e-mail",
    popup_phone: "Numéro de téléphone (optionnel)",
    popup_submit: "Rejoindre",
    popup_skip: "Plus tard",
    popup_thanks: "Merci ! Tu es dans le club. ★",
    popup_email_required: "E-mail requis",
    coming_kicker: "Drop 01",
    coming_title: "Bientôt",
    coming_subtitle: "Le drop arrive. Laisse ton email et ton numéro — tu seras le premier prévenu.",
    coming_notify: "Préviens-moi",
    coming_thanks: "Tu es sur la liste. ★",
    coming_locked: "Site verrouillé jusqu'au lancement",
  },
  en: {
    nav_shop: "Shop",
    nav_drops: "Drops",
    nav_story: "Story",
    nav_contact: "Contact",
    nav_admin: "Admin",
    cart: "Cart",
    drop_live: "Drop 01 — Live now",
    hero_subtitle:
      "An all-black uniform for the streets. Heavyweight cuts, raw seams, green star crest. Made limited. Worn loud.",
    hero_shop: "Shop the drop",
    hero_story: "Our story",
    hero_est: "★ EST. 2025",
    hero_tagline: "All Black / Green Crest",
    featured_kicker: "Featured · Drop 01",
    featured_title: "The essentials",
    view_all: "View all",
    story_kicker: "Our Story",
    story_title_1: "Built",
    story_title_2: "in the",
    story_title_3: "dark.",
    story_body:
      "ALLSTAR is a streetwear label obsessed with one color — black. We cut heavyweight fabrics, finish with raw seams, and stamp every piece with the green star crest. No collections for everyone. Limited runs for the ones paying attention.",
    stat_1: "Limited",
    stat_2: "Heavyweight",
    stat_3: "All Black",
    shop_kicker: "The Shop",
    shop_title: "All Products",
    pieces_live: (n) => `${n} ${n === 1 ? "piece" : "pieces"} live`,
    cat_all: "All",
    cat_tshirt: "T-Shirts",
    cat_tracksuit: "Tracksuits",
    cat_hoodie: "Hoodies",
    cat_tuque: "Beanies",
    cat_manteau: "Jackets",
    add_cart: "Add to cart",
    featured_badge: "Featured",
    stock_left: (n) => `${n} left`,
    sold_out: "Sold out",
    sizes: "Sizes",
    empty_drop: "Nothing in this drop yet. Check back soon.",
    empty_all: "No products yet. Drop coming soon.",
    footer_shop: "Shop",
    footer_all: "All Products",
    footer_tees: "Tees",
    footer_tracksuits: "Tracksuits",
    footer_follow: "Follow",
    footer_tagline:
      "Built in the dark. Worn loud. Drop 01 — all black everything.",
    footer_rights: "© ALLSTAR — All Black Everything",
    footer_made: "Made for the streets",
    popup_title: "Join the club",
    popup_subtitle: "Be first to know about new drops and exclusive ALLSTAR offers.",
    popup_email: "Email address",
    popup_phone: "Phone number (optional)",
    popup_submit: "Join",
    popup_skip: "Maybe later",
    popup_thanks: "You're in the club. ★",
    popup_email_required: "Email required",
    coming_kicker: "Drop 01",
    coming_title: "Coming Soon",
    coming_subtitle: "The drop is loading. Leave your email and phone — you'll be first to know.",
    coming_notify: "Notify me",
    coming_thanks: "You're on the list. ★",
    coming_locked: "Site locked until launch",
  },
  zh: {
    nav_shop: "商店",
    nav_drops: "新品",
    nav_story: "品牌故事",
    nav_contact: "联系",
    nav_admin: "管理",
    cart: "购物车",
    drop_live: "Drop 01 — 现已发售",
    hero_subtitle:
      "街头风格,纯黑制服。重磅剪裁、毛边工艺、标志性绿色星徽。限量制作,响亮上身。",
    hero_shop: "选购系列",
    hero_story: "我们的故事",
    hero_est: "★ 创立于 2025",
    hero_tagline: "全黑 / 绿星徽",
    featured_kicker: "精选 · Drop 01",
    featured_title: "核心单品",
    view_all: "查看全部",
    story_kicker: "我们的故事",
    story_title_1: "诞生",
    story_title_2: "于",
    story_title_3: "黑暗。",
    story_body:
      "ALLSTAR 是一个只痴迷于一种颜色的街头品牌 —— 黑色。我们使用重磅面料,毛边收口,每件单品都印有绿色星徽。不为所有人设计。只为那些懂的人推出限量系列。",
    stat_1: "限量",
    stat_2: "重磅",
    stat_3: "全黑",
    shop_kicker: "商店",
    shop_title: "全部商品",
    pieces_live: (n) => `共 ${n} 件在售`,
    cat_all: "全部",
    cat_tshirt: "T恤",
    cat_tracksuit: "运动套装",
    cat_hoodie: "卫衣",
    cat_tuque: "毛线帽",
    cat_manteau: "外套",
    add_cart: "加入购物车",
    featured_badge: "精选",
    stock_left: (n) => `剩 ${n} 件`,
    sold_out: "已售罄",
    sizes: "尺码",
    empty_drop: "本系列暂无商品,敬请期待。",
    empty_all: "暂无商品,新品即将上线。",
    footer_shop: "商店",
    footer_all: "全部商品",
    footer_tees: "T恤",
    footer_tracksuits: "运动套装",
    footer_follow: "关注",
    footer_tagline: "诞生于黑暗。响亮上身。Drop 01 —— 全黑一切。",
    footer_rights: "© ALLSTAR — 全黑一切",
    footer_made: "为街头而生",
    popup_title: "加入俱乐部",
    popup_subtitle: "第一时间获取 ALLSTAR 新品发布和独家优惠。",
    popup_email: "电子邮箱",
    popup_phone: "电话号码(可选)",
    popup_submit: "加入",
    popup_skip: "稍后再说",
    popup_thanks: "欢迎加入俱乐部 ★",
    popup_email_required: "请输入邮箱",
    coming_kicker: "Drop 01",
    coming_title: "即将发售",
    coming_subtitle: "新品即将上线。留下您的邮箱和电话 —— 第一时间通知您。",
    coming_notify: "通知我",
    coming_thanks: "您已加入名单 ★",
    coming_locked: "网站发售前锁定",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(
    () => localStorage.getItem("allstar_lang") || "en"
  );

  useEffect(() => {
    localStorage.setItem("allstar_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key, ...args) => {
    const dict = translations[lang] || translations.en;
    const v = dict[key];
    if (typeof v === "function") return v(...args);
    return v ?? key;
  };

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}

export const LANGUAGES = [
  { code: "en", label: "EN" },
  { code: "fr", label: "FR" },
  { code: "zh", label: "中文" },
];
